/* SES Palma · portal de mayoristas · «Análisis» (#/analisis): histórico y sell-through de la empresa.
   Datos: portal_analytics (una fila por empresa y temporada, RLS por empresa), calculados en el CRM.
   Sell-through = vendido / (recibido + stock arrastrado de temporadas anteriores), solo en tiendas que
   nos reportan sus ventas (consignación); en compra en firme no hay venta conocida y no se inventa.
   Modo de desarrollo: ?b2bfixture=1 (o sessionStorage ses_b2b_fixture=1) carga datos FICTICIOS de
   ses-b2b-analytics-fixture.js en lugar de Supabase. Nunca se activa solo. */
(function () {
  'use strict';
  const B = window.SESB2B;
  if (!B) return;
  const { esc, t } = B;

  B.extend({
    an_nav:        { es: 'Análisis', en: 'Insights', fr: 'Analyse', it: 'Analisi' },
    an_title:      { es: 'Análisis', en: 'Insights', fr: 'Analyse', it: 'Analisi' },
    an_sub:        { es: 'Tus compras y cómo se venden en tienda, temporada a temporada.', en: 'What you bought and how it sells in store, season by season.', fr: 'Vos achats et leur vente en boutique, saison après saison.', it: 'I tuoi acquisti e come vendono in negozio, stagione dopo stagione.' },
    an_asof:       { es: 'Datos al {date}', en: 'Data as of {date}', fr: 'Données au {date}', it: 'Dati al {date}' },
    an_season:     { es: 'Temporada', en: 'Season', fr: 'Saison', it: 'Stagione' },
    an_store:      { es: 'Tienda', en: 'Store', fr: 'Boutique', it: 'Negozio' },
    an_all_stores: { es: 'Todas las tiendas', en: 'All stores', fr: 'Toutes les boutiques', it: 'Tutti i negozi' },
    an_k_units:    { es: 'Unidades pedidas', en: 'Units ordered', fr: 'Unités commandées', it: 'Pezzi ordinati' },
    an_k_units_n:  { es: '{n} recibidas', en: '{n} received', fr: '{n} reçues', it: '{n} ricevuti' },
    an_k_units_r:  { es: 'Unidades recibidas', en: 'Units received', fr: 'Unités reçues', it: 'Pezzi ricevuti' },
    an_k_st:       { es: 'Sell-through', en: 'Sell-through', fr: 'Sell-through', it: 'Sell-through' },
    an_k_st_n:     { es: '{sold} vendidas de {base}', en: '{sold} sold of {base}', fr: '{sold} vendues sur {base}', it: '{sold} venduti su {base}' },
    an_k_st_none:  { es: 'Sin ventas reportadas', en: 'No sales reported', fr: 'Aucune vente déclarée', it: 'Nessuna vendita riportata' },
    an_k_best:     { es: 'Superventas', en: 'Best seller', fr: 'Meilleure vente', it: 'Più venduto' },
    an_k_top:      { es: 'Lo más comprado', en: 'Most bought', fr: 'Le plus acheté', it: 'Il più acquistato' },
    an_k_stock:    { es: 'Stock en tienda', en: 'Stock in store', fr: 'Stock en boutique', it: 'Stock in negozio' },
    an_k_stock_n:  { es: 'Unidades aún por vender', en: 'Units still to sell', fr: 'Unités encore à vendre', it: 'Pezzi ancora da vendere' },
    an_k_cover:    { es: '≈ {n} semanas de cobertura al ritmo de {month}', en: '≈ {n} weeks of cover at the {month} pace', fr: '≈ {n} semaines de couverture au rythme de {month}', it: '≈ {n} settimane di copertura al ritmo di {month}' },
    an_k_hot:      { es: 'Tallas que se agotan', en: 'Sizes selling out', fr: 'Tailles en rupture', it: 'Taglie in esaurimento' },
    an_k_hot_n:    { es: 'Candidatas a reponer', en: 'Reorder candidates', fr: 'À réassortir', it: 'Da riassortire' },
    an_k_hot_none: { es: 'Ninguna talla al 80 % todavía', en: 'No size at 80 % yet', fr: 'Aucune taille à 80 % pour l\'instant', it: 'Nessuna taglia all\'80 % per ora' },
    an_k_avg:      { es: 'Unidades por estilo', en: 'Units per style', fr: 'Unités par modèle', it: 'Pezzi per modello' },
    an_k_avg_n:    { es: '{n} estilos comprados', en: '{n} styles bought', fr: '{n} modèles achetés', it: '{n} modelli acquistati' },
    an_d_pts:      { es: '{d} pts vs {season}', en: '{d} pts vs {season}', fr: '{d} pts vs {season}', it: '{d} pt vs {season}' },
    an_d_pct:      { es: '{d} % vs {season}', en: '{d}% vs {season}', fr: '{d} % vs {season}', it: '{d}% vs {season}' },
    an_k_value:    { es: 'Valor', en: 'Value', fr: 'Valeur', it: 'Valore' },
    an_k_value_n:  { es: 'A tu precio mayorista, sin IVA', en: 'At your wholesale price, excl. VAT', fr: 'À votre prix de gros, HT', it: 'Al tuo prezzo all\'ingrosso, IVA escl.' },
    an_weeks:      { es: '{n} semanas en tienda', en: '{n} weeks on floor', fr: '{n} semaines en boutique', it: '{n} settimane in negozio' },
    an_ch_seasons: { es: 'Sell-through por temporada', en: 'Sell-through by season', fr: 'Sell-through par saison', it: 'Sell-through per stagione' },
    an_ch_months:  { es: 'Sell-through acumulado · {season}', en: 'Cumulative sell-through · {season}', fr: 'Sell-through cumulé · {season}', it: 'Sell-through cumulato · {season}' },
    an_ch_seasons_aria: { es: 'Gráfico de líneas: sell-through por temporada. {points}.', en: 'Line chart: sell-through by season. {points}.', fr: 'Graphique : sell-through par saison. {points}.', it: 'Grafico: sell-through per stagione. {points}.' },
    an_ch_months_aria:  { es: 'Gráfico de líneas: sell-through acumulado por mes. {points}.', en: 'Line chart: cumulative sell-through by month. {points}.', fr: 'Graphique : sell-through cumulé par mois. {points}.', it: 'Grafico: sell-through cumulato per mese. {points}.' },
    an_ch_one:     { es: 'Hace falta más de una temporada con ventas para ver la evolución.', en: 'More than one season with sales is needed to show a trend.', fr: 'Il faut plus d\'une saison avec des ventes pour voir l\'évolution.', it: 'Serve più di una stagione con vendite per vedere l\'andamento.' },
    an_ch_nomonth: { es: 'Aún no hay ventas mensuales en esta temporada.', en: 'No monthly sales in this season yet.', fr: 'Pas encore de ventes mensuelles cette saison.', it: 'Ancora nessuna vendita mensile in questa stagione.' },
    an_month:      { es: 'Mes', en: 'Month', fr: 'Mois', it: 'Mese' },
    an_sold_month: { es: 'Vendidas en el mes', en: 'Sold in month', fr: 'Vendues dans le mois', it: 'Venduti nel mese' },
    an_by_style:   { es: 'Por estilo y color', en: 'By style and colour', fr: 'Par modèle et couleur', it: 'Per modello e colore' },
    an_by_store:   { es: 'Por tienda', en: 'By store', fr: 'Par boutique', it: 'Per negozio' },
    an_col_item:   { es: 'Estilo · color', en: 'Style · colour', fr: 'Modèle · couleur', it: 'Modello · colore' },
    an_col_size:   { es: 'Talla', en: 'Size', fr: 'Taille', it: 'Taglia' },
    an_col_ord:    { es: 'Pedidas', en: 'Ordered', fr: 'Commandées', it: 'Ordinati' },
    an_col_rec:    { es: 'Recibidas', en: 'Received', fr: 'Reçues', it: 'Ricevuti' },
    an_col_sold:   { es: 'Vendidas', en: 'Sold', fr: 'Vendues', it: 'Venduti' },
    an_col_ret:    { es: 'Devueltas', en: 'Returned', fr: 'Retournées', it: 'Resi' },
    an_col_st:     { es: 'Sell-through', en: 'Sell-through', fr: 'Sell-through', it: 'Sell-through' },
    an_col_weeks:  { es: 'Semanas', en: 'Weeks', fr: 'Semaines', it: 'Settimane' },
    an_group:      { es: 'Agrupar', en: 'Group', fr: 'Regrouper', it: 'Raggruppa' },
    an_group_color:{ es: 'Estilo · color', en: 'Style · colour', fr: 'Modèle · couleur', it: 'Modello · colore' },
    an_group_style:{ es: 'Por estilo', en: 'By style', fr: 'Par modèle', it: 'Per modello' },
    an_col_style:  { es: 'Estilo', en: 'Style', fr: 'Modèle', it: 'Modello' },
    an_color1:     { es: '1 color', en: '1 colour', fr: '1 couleur', it: '1 colore' },
    an_colors:     { es: '{n} colores', en: '{n} colours', fr: '{n} couleurs', it: '{n} colori' },
    an_colors_of:  { es: 'Colores de {name}', en: 'Colours of {name}', fr: 'Couleurs de {name}', it: 'Colori di {name}' },
    an_sort_by:    { es: 'Ordenar por {col}', en: 'Sort by {col}', fr: 'Trier par {col}', it: 'Ordina per {col}' },
    an_sizes:      { es: 'Tallas de {name}', en: 'Sizes of {name}', fr: 'Tailles de {name}', it: 'Taglie di {name}' },
    an_carry:      { es: '+{n} de antes', en: '+{n} carried over', fr: '+{n} reportées', it: '+{n} riportati' },
    an_firm_note:  { es: 'Las tiendas con compra en firme no nos reportan sus ventas: ahí ves lo comprado y recibido, sin sell-through.', en: 'Stores on wholesale orders do not report their sales to us: you see what was bought and received, without sell-through.', fr: 'Les boutiques en achat ferme ne nous déclarent pas leurs ventes : vous voyez l\'acheté et le reçu, sans sell-through.', it: 'I negozi con acquisto a fermo non ci comunicano le vendite: vedi acquistato e ricevuto, senza sell-through.' },
    an_pooled_note:{ es: 'Parte de la mercancía se entregó en vuestro almacén común, sin reparto por tienda: las cifras son de toda la empresa.', en: 'Part of the goods went to your shared warehouse without a split by store: figures are for the whole company.', fr: 'Une partie de la marchandise a été livrée à votre entrepôt commun, sans répartition par boutique : les chiffres sont ceux de toute la société.', it: 'Parte della merce è stata consegnata al vostro magazzino comune, senza ripartizione per negozio: i dati sono dell\'intera azienda.' },
    an_def:        { es: 'Sell-through = vendidas ÷ (recibidas + stock que quedaba de temporadas anteriores). Ventas netas de devoluciones de clientes.', en: 'Sell-through = sold ÷ (received + stock left from earlier seasons). Sales net of customer returns.', fr: 'Sell-through = vendues ÷ (reçues + stock restant des saisons précédentes). Ventes nettes des retours clients.', it: 'Sell-through = venduti ÷ (ricevuti + stock rimasto dalle stagioni precedenti). Vendite al netto dei resi dei clienti.' },
    an_empty:      { es: 'Todavía no hay datos de compras y ventas de tu empresa. Aparecerán aquí cuando SES publique la próxima actualización.', en: 'There is no purchase or sales data for your company yet. It will appear here after the next SES update.', fr: 'Aucune donnée d\'achats ou de ventes pour votre société pour l\'instant. Elles apparaîtront après la prochaine mise à jour de SES.', it: 'Non ci sono ancora dati di acquisti e vendite della tua azienda. Compariranno dopo il prossimo aggiornamento di SES.' },
    an_units:      { es: '{n} uds', en: '{n} units', fr: '{n} unités', it: '{n} pz' },
    an_see_orders: { es: 'Ver mis pedidos', en: 'See my orders', fr: 'Voir mes commandes', it: 'Vedi i miei ordini' },
    an_more:       { es: 'Ver {n} más', en: 'Show {n} more', fr: 'Voir {n} de plus', it: 'Mostra altri {n}' },
    an_fixture:    { es: 'Datos de ejemplo (modo desarrollo)', en: 'Sample data (dev mode)', fr: 'Données d\'exemple (mode dev)', it: 'Dati di esempio (modalità sviluppo)' },
  });

  /* ---------- números ---------- */
  // sell-through de cabecera con un decimal, como la ficha del comercio en el CRM
  const pct1 = (v) => (v == null || !isFinite(v) ? '—'
    : new Intl.NumberFormat(B.locale(), { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(v));
  const pct = (v) => (v == null || !isFinite(v) ? '—'
    : new Intl.NumberFormat(B.locale(), { style: 'percent', maximumFractionDigits: 0 }).format(v));
  const int = (n) => B.fmtInt(n || 0);
  const money0 = (n, cur) => new Intl.NumberFormat(B.locale(), { style: 'currency', currency: cur || 'EUR', maximumFractionDigits: 0 }).format(n);
  const ratio = (sold, base) => (base > 0 && sold != null ? sold / base : null);
  function seasonKey(s) {
    const m = /^(SS|AW|FW)(\d{2})$/i.exec(s || '');
    return m ? Number(m[2]) * 10 + (m[1].toUpperCase() === 'SS' ? 0 : 5) : 0;
  }
  function monthLabel(ym, withYear) {
    const [y, m] = String(ym).split('-').map(Number);
    return new Date(y, m - 1, 1).toLocaleDateString(B.locale(), withYear ? { month: 'short', year: '2-digit' } : { month: 'short' }).replace('.', '');
  }
  const price = (i) => (i.p == null ? null : Number(i.p));

  /* Totales de un conjunto de líneas tienda × SKU. El sell-through solo suma líneas de tiendas que reportan ventas.
     «Unidades» = pedidas si el conjunto tiene pedido; si no (temporadas anteriores al portal), recibidas.
     Nunca se mezclan por SKU: una talla recibida de más o cambiada no suma a lo pedido. */
  function totals(items) {
    const s = { o: 0, r: 0, ci: 0, rt: 0, rtT: 0, bought: 0, sold: null, base: 0, value: 0, valueKnown: true };
    items.forEach((i) => {
      s.o += i.o; s.r += i.r; s.ci += i.ci || 0; s.rt += i.rt;
      if (i.x != null) { s.sold = (s.sold || 0) + i.x; s.base += i.r + (i.ci || 0); s.rtT += i.rt; }
    });
    s.ordered = s.o > 0;
    s.bought = s.ordered ? s.o : s.r;
    items.forEach((i) => {
      const u = s.ordered ? i.o : i.r;
      const p = price(i);
      if (p == null) { if (u > 0) s.valueKnown = false; } else s.value += p * u;
    });
    s.st = ratio(s.sold, s.base);
    return s;
  }
  /* Cifras de cabecera: las que publica el CRM (data.kpi, services/customer_sell_through.py, las mismas de la
     ficha del comercio y del PDF). Sin data.kpi (maqueta) se calculan con la misma fórmula. */
  function headline(data, store) {
    const s = totals(filterItems(data, store));
    const k = data.kpi && (store ? data.kpi.stores && data.kpi.stores[store] : data.kpi.all);
    if (k) {
      // unidades y valor con la regla de totals() (el units_bought del CRM mezcla pedidas y recibidas por SKU)
      if (k.units_ordered != null) s.o = k.units_ordered;
      s.r = k.units_received; s.ordered = s.o > 0; s.bought = s.ordered ? s.o : s.r;
      s.sold = k.units_sold; s.base = k.sell_through_base;
      s.st = k.sell_through_pct == null ? null : k.sell_through_pct / 100;
      s.stock = k.stock_in_store;
    }
    if (s.stock === undefined) s.stock = s.sold == null ? null : Math.max(0, s.base - s.sold - s.rtT);
    return s;
  }
  function filterItems(data, store) {
    return (data.items || []).filter((i) => !store || i.s === store);
  }
  function meta(data, sku) {
    const m = (data.sku || {})[sku] || {};
    return { code: m.sc || sku, name: m.sn || m.sc || sku, color: m.c || '', hex: m.h, size: m.z || '', order: m.zo == null ? 99 : m.zo };
  }

  /* ---------- gráficos SVG (líneas finas, sin rejilla, etiquetas directas) ---------- */
  function lineChart(points, opts) {
    // points: [{label, v (0..1), sub?}] ; ancho real del contenedor para que el texto no se deforme
    const W = Math.max(280, Math.round(opts.width || 640));
    const H = opts.height || 180;
    const padX = 28, top = 26, bottom = 30;
    const n = points.length;
    const max = Math.max(1, ...points.map((p) => p.v || 0));
    const x = (i) => (n === 1 ? W / 2 : padX + (i * (W - padX * 2)) / (n - 1));
    const y = (v) => top + (1 - v / max) * (H - top - bottom);
    const path = points.map((p, i) => `${i ? 'L' : 'M'}${x(i).toFixed(1)},${y(p.v).toFixed(1)}`).join(' ');
    const last = n - 1;
    const every = Math.ceil(n / Math.max(2, Math.floor(W / 64)));
    return `<svg class="an-svg" viewBox="0 0 ${W} ${H}" width="${W}" height="${H}" role="img" aria-label="${esc(opts.aria)}" focusable="false">
      <line class="an-axis" x1="0" x2="${W}" y1="${H - bottom + 0.5}" y2="${H - bottom + 0.5}"/>
      ${n > 1 ? `<path class="an-line" d="${path}"/>` : ''}
      ${points.map((p, i) => `<g class="an-pt${i === last ? ' is-last' : ''}">
        <circle cx="${x(i).toFixed(1)}" cy="${y(p.v).toFixed(1)}" r="${i === last ? 3.5 : 2.5}"/>
        ${i === last || i % every === 0 || n <= 8 ? `<text class="an-val" x="${x(i).toFixed(1)}" y="${(y(p.v) - 10).toFixed(1)}" text-anchor="middle">${esc(pct(p.v))}</text>` : ''}
        ${i % every === 0 || i === last ? `<text class="an-tick" x="${x(i).toFixed(1)}" y="${H - 10}" text-anchor="middle">${esc(p.label)}</text>` : ''}
      </g>`).join('')}
    </svg>`;
  }
  // línea mínima de 1px (decorativa: el dato está en el texto y en los gráficos con tabla accesible)
  function spark(vals) {
    const W = 120, H = 24, n = vals.length;
    const lo = Math.min(...vals), hi = Math.max(...vals), span = hi - lo || 1;
    const pts = vals.map((v, i) => [(i * (W - 4)) / (n - 1) + 2, H - 3 - ((v - lo) / span) * (H - 6)]);
    const d = pts.map((p, i) => `${i ? 'L' : 'M'}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(' ');
    const l = pts[n - 1];
    return `<svg class="an-spark" viewBox="0 0 ${W} ${H}" width="${W}" height="${H}" aria-hidden="true" focusable="false"><path d="${d}"/><circle cx="${l[0].toFixed(1)}" cy="${l[1].toFixed(1)}" r="1.75"/></svg>`;
  }
  const B_parse = (iso) => { const [y, m, d] = String(iso).split('-').map(Number); return new Date(y, m - 1, d || 1); };
  const signed = (n) => (n > 0 ? '+' : n < 0 ? '\u2212' : '±') + Math.abs(n);
  function srTable(caption, head, rows) {
    return `<table class="bp-sr"><caption>${esc(caption)}</caption><thead><tr>${head.map((h) => `<th scope="col">${esc(h)}</th>`).join('')}</tr></thead>
      <tbody>${rows.map((r) => `<tr><th scope="row">${esc(r[0])}</th>${r.slice(1).map((c) => `<td>${esc(c)}</td>`).join('')}</tr>`).join('')}</tbody></table>`;
  }
  function bar(v) {
    const w = v == null ? 0 : Math.max(0, Math.min(1, v)) * 100;
    return `<span class="an-bar" aria-hidden="true"><span class="an-bar-fill" style="width:${w.toFixed(1)}%"></span></span>`;
  }

  /* ---------- carga ---------- */
  const FIXTURE_KEY = 'ses_b2b_fixture';
  function fixtureMode() {
    try {
      const q = new URLSearchParams(location.search).get('b2bfixture');
      if (q === '1') B.ss.set(FIXTURE_KEY, '1');
      if (q === '0') B.ss.del(FIXTURE_KEY);
    } catch (_) { /* sin URLSearchParams */ }
    return B.ss.get(FIXTURE_KEY) === '1';
  }
  function loadFixture() {
    if (window.SES_B2B_ANALYTICS_FIXTURE) return Promise.resolve(window.SES_B2B_ANALYTICS_FIXTURE);
    return new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = (window.SES_ASSET_BASE || '/') + 'ses-b2b-analytics-fixture.js';
      s.onload = () => resolve(window.SES_B2B_ANALYTICS_FIXTURE);
      s.onerror = () => reject(new Error('fixture'));
      document.head.appendChild(s);
    });
  }

  /* ---------- estado de la vista ---------- */
  // byStyle: tabla agrupada por estilo (estilo > color > talla); sort: { col, dir } o null (más vendido primero)
  const GROUP_KEY = 'ses_b2b_an_by_style';
  const V = { season: null, store: '', open: new Set(), limit: 12, byStyle: false, sort: null };
  try { V.byStyle = localStorage.getItem(GROUP_KEY) === '1'; } catch (_) { /* sin almacenamiento */ }

  /* Pinta la vista en `root` a partir de las filas. ctx (opcional): integración con el portal
     (pedidos e «Repetir pedido»). Sin ctx se usa en la maqueta estática. */
  function paint(root, rows, ctx) {
    const c = ctx || {};
    if (c.isActive && !c.isActive()) return;
    rows = (rows || []).filter((r) => r && r.data && (r.data.items || []).length)
      .sort((a, b) => seasonKey(a.season) - seasonKey(b.season));
    const head = `<header class="bp-head"><h1 class="bp-title" tabindex="-1">${esc(t('an_title'))}</h1><p class="bp-sub">${esc(t('an_sub'))}</p></header>`;
    if (!rows.length) {
      root.innerHTML = head + `<div class="bp-empty"><p>${esc(t('an_empty'))}</p>${c.ordersHref ? `<a class="b2b-btn b2b-btn--secondary" href="${esc(c.ordersHref)}">${esc(t('an_see_orders'))}</a>` : ''}</div>`;
      return;
    }
    const seasons = rows.map((r) => r.season);
    if (!seasons.includes(V.season)) {
      // por defecto, la última temporada con ventas; si no hay, la última
      const withSales = rows.filter((r) => totals(r.data.items).sold);
      V.season = (withSales.length ? withSales[withSales.length - 1] : rows[rows.length - 1]).season;
    }
    const row = rows.find((r) => r.season === V.season);
    const data = row.data;
    const storesAll = new Map();
    rows.forEach((r) => (r.data.stores || []).forEach((s) => storesAll.set(s.id, s)));
    const seasonStores = data.stores || [];
    // entregas a un almacén compartido sin tienda: la empresa se ve en bloque, sin filtro por tienda
    const pooled = rows.some((r) => r.data.pooled);
    if (pooled || (V.store && !seasonStores.some((s) => s.id === V.store))) V.store = '';
    const items = filterItems(data, V.store);
    const tot = headline(data, V.store);
    const anyFirm = seasonStores.some((s) => !s.tracked && (!V.store || s.id === V.store));

    const weeks = seasonStores.filter((s) => !V.store || s.id === V.store).map((s) => s.weeks).filter((w) => w != null);
    const weeksMax = weeks.length ? Math.max(...weeks) : null;

    /* serie por temporada (misma tienda) */
    const seasonPts = rows.map((r) => ({ label: r.season, t: headline(r.data, V.store) }))
      .filter((p) => p.t.st != null).map((p) => ({ label: p.label, v: p.t.st, t: p.t }));
    /* serie mensual acumulada de la temporada elegida */
    const monthly = new Map();
    (data.months || []).forEach((m) => { if (!V.store || m.s === V.store) monthly.set(m.m, (monthly.get(m.m) || 0) + m.u); });
    let cum = 0;
    const monthPts = [...monthly.keys()].sort().map((k) => { cum += monthly.get(k); return { label: monthLabel(k), ym: k, u: monthly.get(k), v: ratio(cum, tot.base) || 0 }; });
    const multiYear = new Set([...monthly.keys()].map((k) => k.slice(0, 4))).size > 1;
    if (multiYear) monthPts.forEach((p) => { p.label = monthLabel(p.ym, true); });

    const chartW = Math.min(720, (root.clientWidth || 640) - 2);
    const halfW = window.matchMedia && window.matchMedia('(min-width: 900px)').matches ? (chartW - 32) / 2 : chartW;

    // unidades de un grupo en la base del conjunto (pedidas si la temporada tiene pedido; si no, recibidas)
    const units = (g) => (tot.ordered ? g.t.o : g.t.r);
    /* tabla estilo · color con tallas desplegables */
    const groups = new Map();
    items.forEach((i) => {
      const m = meta(data, i.k);
      const key = `${m.code}|${m.color}`;
      const g = groups.get(key) || { key, name: m.name, color: m.color, hex: m.hex, sizes: new Map() };
      const sz = g.sizes.get(m.size) || { size: m.size, order: m.order, items: [] };
      sz.items.push(i); g.sizes.set(m.size, sz); groups.set(key, g);
    });
    const tableRows = [...groups.values()].map((g) => Object.assign(g, { t: totals([...g.sizes.values()].flatMap((s) => s.items)) }))
      .sort((a, b) => (b.t.sold || 0) - (a.t.sold || 0) || units(b) - units(a) || a.name.localeCompare(b.name));
    const tracked = tot.sold != null;
    if (V.sort && (V.sort.col === 'x' || V.sort.col === 'st') && !tracked) V.sort = null;
    // orden de la tabla: por la cabecera elegida o, por defecto, lo más vendido (o comprado) primero
    const SORT = {
      name: (g) => g.name + ' ' + (g.color || ''),
      o: (g) => g.t.o, r: (g) => g.t.r,
      x: (g) => (g.t.sold == null ? -1 : g.t.sold),
      st: (g) => (g.t.st == null ? -1 : g.t.st),
    };
    const byDefault = (a, b) => (b.t.sold || 0) - (a.t.sold || 0) || units(b) - units(a) || a.name.localeCompare(b.name);
    const sortRows = (list) => {
      if (!V.sort) return list.slice().sort(byDefault);
      const f = SORT[V.sort.col];
      const dir = V.sort.dir === 'asc' ? 1 : -1;
      return list.slice().sort((a, b) => {
        const va = f(a), vb = f(b);
        const d = typeof va === 'string' ? va.localeCompare(vb, B.locale()) : va - vb;
        return d * dir || byDefault(a, b);
      });
    };
    // agrupado por estilo: un nivel más (estilo > color > talla)
    const styleGroups = new Map();
    tableRows.forEach((g) => {
      const code = g.key.split('|')[0];
      const sg = styleGroups.get(code) || { key: `S|${code}`, name: g.name, color: '', colors: [] };
      sg.colors.push(g); styleGroups.set(code, sg);
    });
    styleGroups.forEach((sg) => {
      sg.t = totals(sg.colors.flatMap((g) => [...g.sizes.values()].flatMap((z) => z.items)));
      sg.colors = sortRows(sg.colors);
    });
    const topRows = sortRows(V.byStyle ? [...styleGroups.values()] : tableRows);
    const showRows = topRows.slice(0, V.limit);

    /* ---------- KPI: cifra, comparación con la temporada anterior y una línea mínima ---------- */
    const idx = rows.indexOf(row);
    const prevRow = idx > 0 ? rows[idx - 1] : null;
    const prev = prevRow ? headline(prevRow.data, V.store) : null;
    const upTo = rows.slice(0, idx + 1).map((r) => headline(r.data, V.store));
    const vs = { season: prevRow && prevRow.season };
    const deltaPts = (a, b) => (a == null || b == null ? '' : t('an_d_pts', { d: signed(Math.round((a - b) * 100)), season: vs.season }));
    const deltaPct = (a, b) => (!b || a == null ? '' : t('an_d_pct', { d: signed(Math.round(((a - b) / b) * 100)), season: vs.season }));
    const kpis = [];
    if (tracked) {
      kpis.push({ k: t('an_k_st'), v: pct1(tot.st), sub: t('an_k_st_n', { sold: int(tot.sold), base: int(tot.base) }),
        delta: prev ? deltaPts(tot.st, prev.st) : '', spark: monthPts.length > 1 ? monthPts.map((p) => p.v) : seasonPts.map((p) => p.v) });
    }
    // con pedido: pedidas (y cuántas han llegado); sin pedido: recibidas. Solo se compara con la misma unidad.
    const sameBasis = prev && prev.ordered === tot.ordered;
    kpis.push({ k: t(tot.ordered ? 'an_k_units' : 'an_k_units_r'), v: int(tot.bought),
      sub: tot.ordered ? t('an_k_units_n', { n: int(tot.r) }) : '',
      delta: sameBasis ? deltaPct(tot.bought, prev.bought) : '',
      spark: upTo.filter((x) => x.ordered === tot.ordered).map((x) => x.bought) });
    if (tot.value > 0) {
      kpis.push({ k: t('an_k_value'), v: money0(tot.value, data.currency), sub: t('an_k_value_n'),
        delta: prev && prev.ordered === tot.ordered && prev.valueKnown && tot.valueKnown ? deltaPct(tot.value, prev.value) : '', spark: upTo.filter((x) => x.ordered === tot.ordered).map((x) => x.value) });
    }
    // superventas: estilo · color con más unidades vendidas (o, sin ventas reportadas, el más comprado)
    const hero = tableRows.slice().sort((a, b) => (tracked ? (b.t.sold || 0) - (a.t.sold || 0) : 0) || units(b) - units(a))[0];
    if (hero) {
      const heroSeries = rows.slice(0, idx + 1).map((r) => {
        const its = filterItems(r.data, V.store).filter((i) => { const m = meta(r.data, i.k); return `${m.code}|${m.color}` === hero.key; });
        return tracked ? (totals(its).sold || 0) : totals(its).bought;
      });
      const thumb = c.thumb ? c.thumb(hero.key.split('|')[0], hero.color) : null;
      kpis.push({ k: t(tracked ? 'an_k_best' : 'an_k_top'), v: hero.name, v2: hero.color, thumb, hex: hero.hex,
        sub: tracked ? `${t('an_k_st_n', { sold: int(hero.t.sold), base: int(hero.t.base) })} · ${pct(hero.t.st)}` : t('an_units', { n: int(units(hero)) }),
        spark: heroSeries, word: true });
    }
    if (tracked) {
      // stock en tienda = base − vendidas − devueltas; cobertura al ritmo del último mes con ventas
      const stock = tot.stock;
      const lastM = monthPts.length ? monthPts[monthPts.length - 1] : null;
      const perWeek = lastM && lastM.u > 0 ? lastM.u / 4.345 : 0;
      // solo si el último mes con ventas es reciente (temporada en curso): a temporada cerrada no hay ritmo
      const recent = lastM && data.as_of && (B_parse(data.as_of) - new Date(lastM.ym + '-01')) / 864e5 <= 62;
      let left = tot.base;
      kpis.push({ k: t('an_k_stock'), v: int(stock),
        sub: perWeek > 0 && stock > 0 && recent ? t('an_k_cover', { n: int(Math.round(stock / perWeek)), month: lastM.label }) : t('an_k_stock_n'),
        spark: monthPts.length > 1 ? [tot.base].concat(monthPts.map((p) => { left -= p.u; return Math.max(0, left); })) : [] });
      // tallas que se agotan: talla de un estilo·color con ≥80 % vendido y al menos 2 uds de base
      const hot = [];
      tableRows.forEach((g) => g.sizes.forEach((sz) => {
        const st = totals(sz.items);
        if (st.st != null && st.base >= 2 && st.st >= 0.8) hot.push({ label: `${g.name} ${g.color} · ${sz.size}`, st: st.st, sold: st.sold });
      }));
      hot.sort((a, b) => b.st - a.st || b.sold - a.sold);
      kpis.push({ k: t('an_k_hot'), v: int(hot.length), sub: hot.length ? hot.slice(0, 3).map((h) => h.label).join(', ') + (hot.length > 3 ? '…' : '') : t('an_k_hot_none'),
        delta: hot.length ? t('an_k_hot_n') : '', spark: [] });
    } else {
      const perStyle = (r) => {
        const its = filterItems(r.data, V.store);
        const tt = totals(its);
        const n = new Set(its.filter((i) => (tt.ordered ? i.o : i.r) > 0).map((i) => meta(r.data, i.k).code)).size;
        return { n, avg: n ? tt.bought / n : 0, ordered: tt.ordered };
      };
      const cur = perStyle(row);
      const before = prevRow ? perStyle(prevRow) : null;
      kpis.push({ k: t('an_k_avg'), v: cur.n ? cur.avg.toLocaleString(B.locale(), { maximumFractionDigits: 1 }) : '—',
        sub: t('an_k_avg_n', { n: int(cur.n) }), delta: before && before.ordered === cur.ordered ? deltaPct(cur.avg, before.avg) : '',
        spark: rows.slice(0, idx + 1).map(perStyle).filter((x) => x.ordered === cur.ordered).map((x) => x.avg) });
    }

    const cell = (tt) => `
      <td class="num u-tnum">${int(tt.o)}</td>
      <td class="num u-tnum an-hide-sm">${int(tt.r)}${tt.ci ? `<span class="an-carry">${esc(t('an_carry', { n: int(tt.ci) }))}</span>` : ''}</td>
      ${tracked ? `<td class="num u-tnum">${tt.sold == null ? '—' : int(tt.sold)}</td>
      <td class="an-st"><span class="an-st-in">${bar(tt.st)}<span class="u-tnum">${pct(tt.st)}</span></span></td>` : ''}`;
    const sizeRows = (g, anc) => [...g.sizes.values()].sort((a, b) => a.order - b.order || a.size.localeCompare(b.size))
      .map((z) => `<tr class="an-size${V.byStyle ? ' an-size--deep' : ''}" data-anc="${anc}"><th scope="row"><span class="an-size-l">${esc(t('an_col_size'))} ${esc(z.size)}</span></th>${cell(totals(z.items))}</tr>`).join('');
    const toggle = (id, key, label, inner) => `<button type="button" class="an-toggle" aria-expanded="${V.open.has(key)}" data-id="${id}" data-key="${esc(key)}">
              <span class="an-chev" aria-hidden="true"></span>${inner}<span class="bp-sr">${esc(label)}</span></button>`;
    const colorInner = (g, withName) => `${g.hex ? `<i class="bp-dot" style="background:${B.safeHex(g.hex)}"></i>` : ''}
              <span class="an-name">${withName ? `<strong>${esc(g.name)}</strong> ` : ''}<span class="${withName ? 'bp-muted' : ''}">${esc(g.color)}</span></span>`;
    // acento de la barra: solo en la primera fila cuando el orden es el de ventas
    const top = (gi) => (!gi && !V.sort ? ' is-top' : '');
    const sortHead = (col, label, cls) => {
      const on = V.sort && V.sort.col === col;
      return `<th scope="col"${cls ? ` class="${cls}"` : ''} aria-sort="${on ? (V.sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}">
        <button type="button" class="an-sort${on ? ' is-on' : ''}" data-sort="${col}" aria-label="${esc(t('an_sort_by', { col: label }))}">${esc(label)}<span class="an-sort-i" aria-hidden="true">${on ? (V.sort.dir === 'asc' ? '↑' : '↓') : ''}</span></button></th>`;
    };
    const groupChips = `<div class="an-filter an-group-by" role="group" aria-label="${esc(t('an_group'))}">
        <button type="button" class="bp-chip" aria-pressed="${!V.byStyle}" data-bystyle="0">${esc(t('an_group_color'))}</button>
        <button type="button" class="bp-chip" aria-pressed="${V.byStyle}" data-bystyle="1">${esc(t('an_group_style'))}</button>
      </div>`;
    const styleTable = `${groupChips}<div class="bp-table-wrap an-table-wrap"><table class="bp-table an-table">
      <caption class="bp-sr">${esc(t('an_by_style'))} · ${esc(V.season)}</caption>
      <thead><tr>${sortHead('name', t(V.byStyle ? 'an_col_style' : 'an_col_item'))}${sortHead('o', t('an_col_ord'), 'num')}
        ${sortHead('r', t('an_col_rec'), 'num an-hide-sm')}
        ${tracked ? `${sortHead('x', t('an_col_sold'), 'num')}${sortHead('st', t('an_col_st'), 'an-st')}` : ''}</tr></thead>
      ${showRows.map((g, gi) => {
        const id = `an-g${gi}`;
        if (!V.byStyle) {
          return `<tbody class="an-group${top(gi)}">
          <tr class="an-row"><th scope="row">${toggle(id, g.key, t('an_sizes', { name: `${g.name} ${g.color}` }), colorInner(g, true))}</th>${cell(g.t)}</tr>
          ${sizeRows(g, id)}
        </tbody>`;
        }
        return `<tbody class="an-group${top(gi)}">
          <tr class="an-row"><th scope="row">${toggle(id, g.key, t('an_colors_of', { name: g.name }),
            `<span class="an-name"><strong>${esc(g.name)}</strong> <span class="bp-muted">${esc(g.colors.length === 1 ? t('an_color1') : t('an_colors', { n: int(g.colors.length) }))}</span></span>`)}</th>${cell(g.t)}</tr>
          ${g.colors.map((c2, ci) => {
            const cid = `${id}c${ci}`;
            return `<tr class="an-row an-row--color" data-anc="${id}"><th scope="row"><span class="an-color-l">${toggle(cid, c2.key, t('an_sizes', { name: `${c2.name} ${c2.color}` }), colorInner(c2, false))}</span></th>${cell(c2.t)}</tr>
          ${sizeRows(c2, `${id} ${cid}`)}`;
          }).join('')}
        </tbody>`;
      }).join('')}
    </table></div>
    ${topRows.length > showRows.length ? `<button type="button" class="b2b-btn b2b-btn--ghost an-more" data-more>${esc(t('an_more', { n: int(topRows.length - showRows.length) }))}</button>` : ''}`;

    /* tabla por tienda (solo si hay varias) */
    const storeRows = seasonStores.map((s) => ({ s, t: totals(filterItems(data, s.id)) }));
    const storeTable = seasonStores.length > 1 && !V.store && !pooled ? `<section class="bp-section an-section" aria-labelledby="anStores">
      <h2 class="bp-h2" id="anStores">${esc(t('an_by_store'))}</h2>
      <div class="bp-table-wrap an-table-wrap"><table class="bp-table an-table">
        <thead><tr><th scope="col">${esc(t('an_store'))}</th><th scope="col" class="num">${esc(t('an_col_ord'))}</th>
          <th scope="col" class="num an-hide-sm">${esc(t('an_col_rec'))}</th><th scope="col" class="num">${esc(t('an_col_sold'))}</th>
          <th scope="col" class="an-st">${esc(t('an_col_st'))}</th><th scope="col" class="num an-hide-sm">${esc(t('an_col_weeks'))}</th></tr></thead>
        <tbody>${storeRows.map(({ s, t: tt }) => `<tr><th scope="row">${esc(s.name || '—')}</th>
          <td class="num u-tnum">${int(tt.o)}</td><td class="num u-tnum an-hide-sm">${int(tt.r)}</td>
          <td class="num u-tnum">${tt.sold == null ? '—' : int(tt.sold)}</td>
          <td class="an-st">${tt.st == null ? '<span class="bp-muted">—</span>' : `<span class="an-st-in">${bar(tt.st)}<span class="u-tnum">${pct(tt.st)}</span></span>`}</td>
          <td class="num u-tnum an-hide-sm">${s.weeks == null ? '—' : int(s.weeks)}</td></tr>`).join('')}</tbody>
      </table></div></section>` : '';

    const storeChips = storesAll.size > 1 && !pooled ? `<div class="an-filter" role="group" aria-label="${esc(t('an_store'))}">
        <button type="button" class="bp-chip" aria-pressed="${!V.store}" data-store="">${esc(t('an_all_stores'))}</button>
        ${seasonStores.map((s) => `<button type="button" class="bp-chip" aria-pressed="${V.store === s.id}" data-store="${esc(s.id)}">${esc(s.name || '—')}</button>`).join('')}
      </div>` : '';

    root.innerHTML = `${head}
      ${c.fixture ? `<p class="an-fixture">${esc(t('an_fixture'))}</p>` : ''}
      <div class="an-filters">
        <div class="an-filter" role="group" aria-label="${esc(t('an_season'))}">
          ${seasons.slice().reverse().map((s) => `<button type="button" class="bp-chip" aria-pressed="${s === V.season}" data-season="${esc(s)}">${esc(s)}</button>`).join('')}
        </div>
        ${storeChips}
      </div>
      <p class="an-asof">${esc(t('an_asof', { date: data.generated_at ? B.fmtDateTime(data.generated_at) : B.fmtDate(data.as_of) }))}${weeksMax != null ? ` · ${esc(t('an_weeks', { n: int(weeksMax) }))}` : ''}</p>

      <dl class="an-kpis an-kpis--${kpis.length}">
        ${kpis.map((x) => `<div class="an-kpi">
          <dt>${esc(x.k)}</dt>
          <dd class="an-kpi-v${x.word ? ' an-kpi-v--word' : ''}">${x.word ? `<span class="an-kpi-hero">${x.thumb ? `<span class="an-thumb-wrap"><img class="an-thumb" src="${esc(x.thumb)}" alt="" loading="lazy" width="44" height="58" data-hex="${esc(x.hex ? B.safeHex(x.hex) : '')}">${x.hex ? `<i class="an-thumb-dot" style="background:${B.safeHex(x.hex)}"></i>` : ''}</span>` : (x.hex ? `<i class="an-thumb an-thumb--swatch" style="background:${B.safeHex(x.hex)}"></i>` : '')}<span>${esc(x.v)}${x.v2 ? `<span class="an-kpi-v2">${esc(x.v2)}</span>` : ''}</span></span>` : `<span class="u-tnum">${esc(x.v)}</span>`}</dd>
          ${x.delta ? `<dd class="an-kpi-d">${esc(x.delta)}</dd>` : ''}
          ${x.sub ? `<dd class="an-kpi-s">${esc(x.sub)}</dd>` : ''}
          ${x.spark && x.spark.length > 1 ? `<dd class="an-kpi-spark">${spark(x.spark)}</dd>` : ''}
        </div>`).join('')}
      </dl>

      <div class="an-charts">
        <section class="an-chart" aria-labelledby="anChS">
          <h2 class="bp-h2" id="anChS">${esc(t('an_ch_seasons'))}</h2>
          ${seasonPts.length ? lineChart(seasonPts, { width: halfW, aria: t('an_ch_seasons_aria', { points: seasonPts.map((p) => `${p.label} ${pct(p.v)}`).join(', ') }) }) : ''}
          ${seasonPts.length < 2 ? `<p class="an-note">${esc(t(seasonPts.length ? 'an_ch_one' : 'an_k_st_none'))}</p>` : ''}
          ${seasonPts.length ? srTable(t('an_ch_seasons'), [t('an_season'), t('an_col_sold'), t('an_col_rec'), t('an_col_st')],
            seasonPts.map((p) => [p.label, int(p.t.sold), int(p.t.base), pct(p.v)])) : ''}
        </section>
        <section class="an-chart" aria-labelledby="anChM">
          <h2 class="bp-h2" id="anChM">${esc(t('an_ch_months', { season: V.season }))}</h2>
          ${monthPts.length ? lineChart(monthPts, { width: halfW, aria: t('an_ch_months_aria', { points: monthPts.map((p) => `${p.label} ${pct(p.v)}`).join(', ') }) })
            : `<p class="an-note">${esc(t(tracked ? 'an_ch_nomonth' : 'an_k_st_none'))}</p>`}
          ${monthPts.length ? srTable(t('an_ch_months', { season: V.season }), [t('an_month'), t('an_sold_month'), t('an_col_st')],
            monthPts.map((p) => [p.label, int(p.u), pct(p.v)])) : ''}
        </section>
      </div>

      <section class="bp-section an-section" aria-labelledby="anStyle">
        <h2 class="bp-h2" id="anStyle">${esc(t('an_by_style'))}</h2>
        ${styleTable}
        ${anyFirm ? `<p class="an-note">${esc(t('an_firm_note'))}</p>` : ''}
        ${pooled && storesAll.size > 1 ? `<p class="an-note">${esc(t('an_pooled_note'))}</p>` : ''}
        ${tracked ? `<p class="an-note">${esc(t('an_def'))}</p>` : ''}
      </section>
      ${storeTable}`;

    const redraw = (focusSel) => {
      if (c.isActive && !c.isActive()) return;
      const y = window.scrollY;
      paint(root, rows, ctx);
      window.scrollTo(0, y);
      const f = focusSel && root.querySelector(focusSel);
      if (f) f.focus({ preventScroll: true });
    };
    root.querySelectorAll('[data-season]').forEach((b) => b.addEventListener('click', () => {
      V.season = b.dataset.season; V.open.clear(); V.limit = 12;
      redraw(`[data-season="${CSS.escape(V.season)}"]`);
    }));
    root.querySelectorAll('[data-store]').forEach((b) => b.addEventListener('click', () => {
      V.store = b.dataset.store; V.open.clear();
      redraw(`[data-store="${CSS.escape(V.store)}"]`);
    }));
    // una fila se ve si todos sus niveles de arriba (data-anc) están desplegados
    const sync = (tbody) => {
      const open = new Set([...tbody.querySelectorAll('.an-toggle[aria-expanded="true"]')].map((b) => b.dataset.id));
      tbody.classList.toggle('is-open', open.size > 0);
      tbody.querySelectorAll('tr[data-anc]').forEach((tr) => { tr.hidden = !tr.dataset.anc.split(' ').every((a) => open.has(a)); });
    };
    root.querySelectorAll('.an-table tbody.an-group').forEach(sync);
    root.querySelectorAll('.an-toggle').forEach((b) => b.addEventListener('click', () => {
      const open = b.getAttribute('aria-expanded') !== 'true';
      if (open) V.open.add(b.dataset.key); else V.open.delete(b.dataset.key);
      b.setAttribute('aria-expanded', String(open));
      sync(b.closest('tbody'));
    }));
    root.querySelectorAll('[data-bystyle]').forEach((b) => b.addEventListener('click', () => {
      V.byStyle = b.dataset.bystyle === '1'; V.limit = 12; V.open.clear();
      try { localStorage.setItem(GROUP_KEY, V.byStyle ? '1' : '0'); } catch (_) { /* sin almacenamiento */ }
      redraw(`[data-bystyle="${b.dataset.bystyle}"]`);
    }));
    // cabeceras: primer clic de mayor a menor (nombre: A-Z), segundo invierte, tercero vuelve al orden por defecto
    root.querySelectorAll('[data-sort]').forEach((b) => b.addEventListener('click', () => {
      const col = b.dataset.sort;
      const first = col === 'name' ? 'asc' : 'desc';
      if (!V.sort || V.sort.col !== col) V.sort = { col, dir: first };
      else if (V.sort.dir === first) V.sort = { col, dir: first === 'asc' ? 'desc' : 'asc' };
      else V.sort = null;
      redraw(`[data-sort="${col}"]`);
    }));
    const more = root.querySelector('[data-more]');
    if (more) more.addEventListener('click', () => { V.limit += 24; redraw(); });
    // foto que no carga (estilo sin foto publicada): muestra de color, nunca el icono de imagen rota
    root.querySelectorAll('img.an-thumb').forEach((img) => img.addEventListener('error', () => {
      const wrap = img.closest('.an-thumb-wrap') || img;
      const sw = document.createElement('i');
      sw.className = 'an-thumb an-thumb--swatch';
      if (img.dataset.hex) sw.style.background = img.dataset.hex;
      wrap.replaceWith(sw);
    }, { once: true }));
  }

  /* re-pinta al cambiar de ancho (los gráficos usan el ancho real) */
  let resizeT = null;
  let last = null;
  function deactivate() {
    clearTimeout(resizeT);
    resizeT = null;
    last = null;
  }
  window.addEventListener('hashchange', deactivate);
  window.addEventListener('resize', () => {
    clearTimeout(resizeT);
    const view = last;
    // Safari changes viewport height while scrolling. Only chart width matters.
    if (!view || view.width === view.root.clientWidth) return;
    resizeT = setTimeout(() => {
      if (last !== view || !document.body.contains(view.root) || !view.ctx.isActive()) return;
      view.width = view.root.clientWidth;
      paint(view.root, view.rows, view.ctx);
    }, 200);
  });

  /* Vista de grupo: une las filas de varias empresas en una por temporada. Las líneas son
     tienda × SKU (tiendas distintas en cada empresa), así que basta con concatenar tiendas, líneas
     y meses; el sell-through se recalcula en paint() con las sumas. Con monedas distintas en una
     temporada no se suma valor: se quita el precio y el KPI de valor no se muestra. */
  function mergeRows(rows) {
    const bySeason = new Map();
    (rows || []).forEach((r) => {
      if (!r || !r.data) return;
      const list = bySeason.get(r.season) || [];
      list.push(r.data);
      bySeason.set(r.season, list);
    });
    return [...bySeason.entries()].map(([season, list]) => {
      if (list.length === 1) return { season, data: list[0] };
      const currencies = new Set(list.map((d) => d.currency || 'EUR'));
      const mixed = currencies.size > 1;
      const asOf = list.map((d) => d.as_of).filter(Boolean).sort();
      const data = {
        v: list[0].v, season, currency: mixed ? null : [...currencies][0],
        as_of: asOf.length ? asOf[asOf.length - 1] : null,
        stores: list.flatMap((d) => d.stores || []),
        items: list.flatMap((d) => (d.items || []).map((i) => (mixed ? Object.assign({}, i, { p: null }) : i))),
        months: list.flatMap((d) => d.months || []),
        sku: Object.assign({}, ...list.map((d) => d.sku || {})),
        pooled: list.some((d) => d.pooled),
      };
      // Cifras del CRM (data.kpi): son sumas por tienda, así que el grupo suma las de sus empresas y
      // recalcula el sell-through con esas sumas. Si a alguna empresa le falta, se calcula como sin kpi.
      if (!mixed && list.every((d) => d.kpi && d.kpi.all)) {
        // null si ninguna empresa lo trae (p. ej. vendido de tiendas en firme, que no reportan sell-out)
        const sum = (f) => (list.every((d) => d.kpi.all[f] == null) ? null
          : list.reduce((acc, d) => acc + (Number(d.kpi.all[f]) || 0), 0));
        const base = sum('sell_through_base');
        const sold = sum('units_sold');
        data.kpi = {
          all: {
            units_bought: sum('units_bought'), units_ordered: list.some((d) => d.kpi.all.units_ordered == null) ? null : sum('units_ordered'), units_received: sum('units_received'), units_sold: sold,
            sell_through_base: base, sell_through_pct: base > 0 && sold != null ? Math.round((sold / base) * 1000) / 10 : null,
            value: sum('value'), value_complete: list.every((d) => !!d.kpi.all.value_complete),
            stock_in_store: sum('stock_in_store'),
          },
          stores: Object.assign({}, ...list.map((d) => d.kpi.stores || {})),
        };
      }
      return { season, data };
    });
  }

  /* Vista del portal: ctx = { MAIN, companyId, companyIds, guard, retry, q, sb, stale, focusMain, thumb } (los pedidos están en #/pedidos) */
  async function view(seq, ctx) {
    const fixture = fixtureMode();
    const data = await ctx.guard(async () => {
      if (fixture) {
        const fx = await loadFixture();
        return { rows: fx.rows };
      }
      const ids = ctx.companyIds && ctx.companyIds.length ? ctx.companyIds : [ctx.companyId];
      const rows = await ctx.q(() => {
        const query = ctx.sb().from('portal_analytics').select('company_id,season,data');
        return ids.length === 1 ? query.eq('company_id', ids[0]) : query.in('company_id', ids);
      });
      return { rows: mergeRows(rows) };
    }, ctx.retry);
    if (!data || ctx.stale(seq)) return;
    // Own a disposable mount: a delayed chart can never replace another tab's MAIN.
    const root = document.createElement('div');
    root.className = 'an-view';
    ctx.MAIN.replaceChildren(root);
    const pctx = { thumb: ctx.thumb, ordersHref: '#/pedidos', fixture,
      isActive: () => !ctx.stale(seq) && root.parentNode === ctx.MAIN };
    last = { root, rows: data.rows, ctx: pctx, width: root.clientWidth };
    paint(root, data.rows, pctx);
    ctx.focusMain();
  }

  B.portalAnalytics = { view, paint, deactivate, totals, mergeRows, _state: V };
})();
